import { Tooltip } from "@ondit/ui";
import { Library } from "@ondit/ui/icons";
import { Gauge } from "lucide-react";
import { NavLink } from "react-router";
import { useTaskInbox } from "~/common/tasks/inbox";
import { useT } from "~/core/i18n";

export function WorkspaceNavigation({
	brandId,
	orgId,
	collapsed,
}: {
	brandId: string;
	orgId: string;
	collapsed: boolean;
}) {
	const t = useT();
	const inbox = useTaskInbox(orgId);
	const count = inbox.isError ? undefined : inbox.data?.items.length;
	const base = `/w/${brandId}`;
	return (
		<div className="nav-group">
			{[
				{ to: base, label: t("nav.overview"), icon: <Gauge />, end: true, badge: undefined },
				{ to: `${base}/tasks`, label: t("tasks.title"), icon: <Library />, end: false, badge: count || undefined },
			].map(({ to, label, icon, end, badge }) => {
				const link = (
					<NavLink key={to} to={to} end={end} aria-label={label} className="nav-item">
						{icon}
						<span className="nav-label">{label}</span>
						{badge ? <span className="badge num">{badge}</span> : null}
					</NavLink>
				);
				return collapsed ? (
					<Tooltip.Root key={to}>
						<Tooltip.Trigger asChild>{link}</Tooltip.Trigger>
						<Tooltip.Content side="right">{badge ? `${label} · ${badge}` : label}</Tooltip.Content>
					</Tooltip.Root>
				) : (
					link
				);
			})}
		</div>
	);
}
